import {FLEETDRIVERINFO} from '../actiontype'
import request from '@/utils/request'
import {fleetDriverInfoApi} from '@/api'
import inlineSign from '@/utils/inlinesign'
export const fleetdriverinfoAction = () => {
  const action = (data) => (
    {
      type: FLEETDRIVERINFO,
      data
    }
  )
  return async (dispatch) => {
    let data = await request.get(fleetDriverInfoApi,{},{
        ...inlineSign
    })
    if(data.data.data){
        dispatch(action(data.data.data))
    }
  }
}